<section class="ngx-messaging-chat" [ngStyle]="{ width: chatSize }">
  <div class="ngx-messaging-chat__header ngx-messaging-chat__header__skeleton">
    <ngx-skeleton-loader
      [count]="1"
      appearance="line"
      animation="false"
      [theme]="{
        'border-radius': '0px 5px 5px 5px',
        height: '57px',
        width: 'calc(100%)',
      }"></ngx-skeleton-loader>
  </div>
  <main class="ngx-messaging-chat__body ngx-messaging-chat__skeleton">
    <div class="skeleton-items">
      <ngx-skeleton-loader
        [count]="8"
        appearance="line"
        animation="false"
        [theme]="{
          'border-radius': '0px 5px 5px 5px',
          height: '150px',
          width: '60%',
        }"></ngx-skeleton-loader>
    </div>
  </main>
  <ng-container>
    <footer class="ngx-messaging-chat__input ngx-messaging-chat__input__skeleton">
      <ngx-skeleton-loader
        animation="false"
        [count]="1"
        appearance="line"
        [theme]="{
          'border-radius': '0px 5px 5px 5px',
          height: '57px',
          width: 'calc(100% - 40px)',
        }"></ngx-skeleton-loader>
    </footer>
  </ng-container>
</section>
